/**
 * The vendor area's sub-navigation (phase 7b): ops, tenants, releases,
 * announcements, audit — plain links whose clicks go to `onNavigate`, the
 * current section marked, and a note that this is the cross-tenant console.
 */
import { isPlainClick } from '../../lib/links.js';
import { cn } from '../../lib/utils.js';

export const VENDOR_SECTIONS: readonly { readonly label: string; readonly href: string }[] = [
  { label: 'Ops', href: '/vendor/ops' },
  { label: 'Tenants', href: '/vendor/tenants' },
  { label: 'Releases', href: '/vendor/releases' },
  { label: 'Announcements', href: '/vendor/announcements' },
  { label: 'Audit', href: '/vendor/audit' },
];

export type VendorNavProps = {
  readonly pathname: string;
  readonly onNavigate: (href: string) => void;
};

export function VendorNav({ pathname, onNavigate }: VendorNavProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 border-b pb-3" data-testid="vendor-nav">
      <span className="text-sm font-semibold">Vendor console</span>
      <span className="text-xs text-muted-foreground">cross-tenant</span>
      <nav aria-label="Vendor" className="flex flex-wrap items-center gap-1">
        {VENDOR_SECTIONS.map((s) => {
          const active = pathname === s.href || pathname.startsWith(`${s.href}/`);
          return (
            <a
              key={s.href}
              href={s.href}
              aria-current={active ? 'page' : undefined}
              onClick={(event) => {
                if (!isPlainClick(event)) return;
                event.preventDefault();
                onNavigate(s.href);
              }}
              className={cn('rounded-md px-3 py-1 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground', active && 'bg-accent text-accent-foreground')}
            >
              {s.label}
            </a>
          );
        })}
      </nav>
    </div>
  );
}
